import React from "react";
import { get } from "lodash";
import {
  displayData,
  getVersionBreaks,
  getVersionRating,
  getVersionStatus,
} from "../../../utils/ContentFinderUtils";

const GeneralItem = ({ label, value }) => (
  <div className="general-item">
    <span className="general-label">{label}</span>
    <span className="general-value">{value}</span>
  </div>
);

const GeneralSection = ({ meta, videoProps, titleId }) => {
  const administrative = get(meta, "administrative", {});
  const width = get(videoProps, "width");
  const height = get(videoProps, "height");
  const versionRating = getVersionRating(administrative);

  return (
    <section className="drawer-section">
      <h2 className="drawer-section-title">General</h2>
      <div className="general-grid">
        <GeneralItem label="Slug" value={displayData(get(administrative, "slug"))} />
        <GeneralItem label="Breaks" value={getVersionBreaks(meta)} />
        <GeneralItem label="Status" value={getVersionStatus(meta)} />
        <GeneralItem
          label="Network"
          value={displayData(get(administrative, "networkName"))}
        />
        <GeneralItem
          label="Frame Aspect Ratio"
          value={displayData(get(videoProps, "aspectRatio"))}
        />
        <GeneralItem
          label="Version Rating"
          value={displayData(versionRating.text, {
            expression: !!versionRating.rating,
          })}
        />
        <GeneralItem
          label="Scan Type"
          value={displayData(get(videoProps, "scanType"), { titleCase: true })}
        />
        <GeneralItem
          label="Normalized"
          value={get(administrative, "normalized") ? "Yes" : "No"}
        />
        <GeneralItem label="Title ID" value={titleId || "---"} />
        <GeneralItem
          label="Resolution"
          value={displayData(`${width} x ${height}`, {
            expression: width && height,
          })}
        />
      </div>
    </section>
  );
};

export default GeneralSection;
